import { render, staticRenderFns } from "./su2Results.vue?vue&type=template&id=006346be&scoped=true"
import script from "./su2Results.vue?vue&type=script&lang=js"
export * from "./su2Results.vue?vue&type=script&lang=js"
import style0 from "./su2Results.vue?vue&type=style&index=0&id=006346be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006346be",
  null
  
)

export default component.exports